<template>
  <section v-on:click="sectionClicked" class="pageSupport" :class="{hasResult: result}">
    <Header ref="header" :class="{scrolled: scrolled}"/>
    <div class="cnt cntTitle">
      <h2 class="pageTitle">Kalkulator Energi</h2>
      <p class="pageSubtitle">Hitung kebutuhan energi suryamu,
        masukan informasi batas daya di rumah kamu.</p>
    </div>
    <div class="form">
      <div class="cnt">
        <div class="theForm">
          <div class="fieldGroup">
            <div class="fieldCnt">
              <input type="text" class="field" placeholder="Lokasi" :value="name" readonly>
              <div class="icon location"></div>
            </div>
          </div>
          <div class="fieldGroup">
            <div class="fieldCnt">
              <select class="field" v-model="form.power.model">
                <option :value="item.id" v-for="(item, i) in powerType" :key="`pwr${i}`">
                  {{item.displayName}}
                </option>
              </select>
              <div class="icon flash"></div>
            </div>
          </div>
          <div class="fieldGroup">
            <div class="fieldCnt">
              <select class="field" v-model="form.type.model">
                <option value="prabayar">Prabayar (Meteran Token)</option>
                <option value="pascabayar">Pascabayaran (Meteran Bulanan)</option>
              </select>
              <div class="icon speedometer"></div>
            </div>
          </div>
          <div class="fieldGroup" :class="{hasError: form.cost.error !== ''}">
            <div class="fieldCnt">
              <input type="number" class="field" placeholder="Biaya rata-rata per bulan"
                v-model="form.cost.model" v-on:input="form.cost.error = ''">
              <div class="icon cashOutline"></div>
            </div>
            <div class="fieldError" v-if="form.cost.error !== ''">{{form.cost.error}}</div>
          </div>
          <button v-on:click="calcNow" class="btn primary" :class="{disabled: loading}">
            <span>Hitung Kebutuhan</span>
          </button>
        </div>
        <div class="theResult" :class="{loading: loading}">
          <div id="result" v-if="result">
            <div class="backBtn" v-on:click="result = null"></div>
            <div class="input">
              <label>Data input</label>
              <div class="inputCnt">
                <div class="inputItem">
                  <div class="icon location"></div>
                  <span>Lokasi</span>
                  <div class="inputValue">{{result.locationName}}</div>
                </div>
                <div class="inputItem">
                  <div class="icon flash"></div>
                  <span>Batas Daya</span>
                  <div class="inputValue">{{result.powerName}}</div>
                </div>
                <div class="inputItem">
                  <div class="icon cashOutline"></div>
                  <span>Biaya per bulan</span>
                  <div class="inputValue">Rp {{result.avgCost.toLocaleString('id')}}</div>
                </div>
              </div>
            </div>
            <div class="output">
              <h4>Berikut hasil perhitungan kebutuhan listrik energi surya saya
                dengan rata-rata kebutuhan {{result.avgKwhPerDay.toFixed(2)}} kWh per harinya*</h4>
              <div class="openSignup" v-if="!$session.get('sc_cl_tk_logged_in')"
                v-on:click="$refs.header.openLogin">
                Untuk save dan share,
                <b>Daftar disini</b></div>
              <div class="fieldGroup">
                <label>Modul yang digunakan</label>
                <div class="fieldCnt">
                  <select class="field" v-model="solarModule" v-on:change="moduleChanged">
                    <option value="50">50 Wp</option>
                    <option value="100">100 Wp</option>
                    <option value="250">250 Wp</option>
                    <option value="350">350 Wp</option>
                    <option value="400">400 Wp</option>
                    <option value="450">450 Wp</option>
                    <option value="500">500 Wp</option>
                  </select>
                </div>
              </div>
              <div class="outputCnt">
                <div class="outputItem main">
                  <h4>Sistem {{result.systemCapacity100}} kWp
                    <span><div class="icon flash"></div> 100%</span></h4>
                  <p>Kebutuhan kapasitas solar panel (Modul {{result.solarModule}} Wp)</p>
                  <div class="tableCnt">
                    <table colspan="0" rowspan="0">
                      <tr><td class="td1">Kebutuhan rata-rata</td>
                        <td class="tdr">{{result.avgKwhPerDay.toFixed(2)}} kWp/hari</td></tr>
                      <tr class="bold"><td>Rekomendasi sistem</td>
                        <td class="tdr">{{result.systemCapacity100}} kWp</td></tr>
                      <tr class="bold"><td>Estimasi produksi plts</td>
                        <td class="tdr">{{result.electricProduced100
                          .toLocaleString('id')}} kWh/bulan )*<sup>1</sup></td></tr>
                      <tr><td>Kebutuhan modul</td><td class="tdr">
                        {{result.moduleCount100}} Modul {{result.solarModule}} Wp</td></tr>
                      <tr><td>Perkiraan biaya</td><td class="tdr">Rp
                        {{result.costEstimated100.toLocaleString('id')}} )*<sup>2</sup></td></tr>
                    </table>
                  </div>
                  <div class="carbonInfo">
                    <div class="icon leaf"></div>
                    Karbon yang dapat dihindari
                    {{result.co2PerKwhInTon100.toLocaleString('id')}} Ton per bulan,
                    atau setara dengan mengendarai mobil sejauh
                    <b>{{result.kmCar100.toLocaleString('id')}} Kilometer</b>
                  </div>
                  <div class="priceInfo">
                    )*<sup>1</sup> Estimasi produksi plts mungkin akan berbeda
                    tergantung cuaca sekitar tempat pemasangan solar panel
                  </div>
                  <div class="priceInfo">
                    )*<sup>2</sup> Perkiraan biaya diambil dari rata-rata nilai
                    jual solar panel dan belum termasuk batre, mungkin akan berbeda sesuai dengan
                    produsen solar panel dan biaya pemasangan di tiap daerah.
                  </div>
                </div>
                <div class="outputItem" :class="{folded: folded.o2}"
                  v-on:click="folded.o2 = !folded.o2">
                  <h4>Sistem {{result.systemCapacity75}} kWp
                    <span><div class="icon flash"></div> 75%</span></h4>
                  <p>Kebutuhan kapasitas solar panel (Modul {{result.solarModule}} Wp)</p>
                  <div class="tableCnt">
                    <table colspan="0" rowspan="0">
                      <tr class="bold"><td>Rekomendasi sistem</td>
                        <td class="tdr">{{result.systemCapacity75}} kWp</td></tr>
                      <tr class="bold"><td>Estimasi produksi plts</td>
                        <td class="tdr">{{result.electricProduced75
                          .toLocaleString('id')}} kWh/bulan )*<sup>1</sup></td></tr>
                      <tr><td>Kebutuhan modul</td><td class="tdr">
                        {{result.moduleCount75}} Modul {{result.solarModule}} Wp</td></tr>
                      <tr><td>Perkiraan biaya</td><td class="tdr">Rp
                        {{result.costEstimated75.toLocaleString('id')}} )*<sup>2</sup></td></tr>
                    </table>
                  </div>
                  <div class="carbonInfo">
                    <div class="icon leaf"></div>
                    Karbon yang dapat dihindari
                    {{result.co2PerKwhInTon50.toLocaleString('id')}} Ton per bulan,
                    atau setara dengan mengendarai mobil sejauh
                    <b>{{result.kmCar50.toLocaleString('id')}} Kilometer</b>
                  </div>
                  <div class="priceInfo">
                    )*<sup>1</sup> Estimasi produksi plts mungkin akan berbeda
                    tergantung cuaca sekitar tempat pemasangan solar panel
                  </div>
                  <div class="priceInfo">
                    )*<sup>2</sup> Perkiraan biaya diambil dari rata-rata nilai
                    jual solar panel dan belum termasuk batre, mungkin akan
                    berbeda sesuai dengan produsen solar panel dan biaya
                    pemasangan di tiap daerah.
                  </div>
                </div>
                <div class="outputItem" :class="{folded: folded.o3}"
                  v-on:click="folded.o3 = !folded.o3">
                  <h4>Sistem {{result.systemCapacity50}} kWp
                    <span><div class="icon flash"></div> 50%</span></h4>
                  <p>Kebutuhan kapasitas solar panel (Modul {{result.solarModule}} Wp)</p>
                  <div class="tableCnt">
                    <table colspan="0" rowspan="0">
                      <tr class="bold"><td>Rekomendasi sistem</td>
                        <td class="tdr">{{result.systemCapacity50}} kWp</td></tr>
                      <tr class="bold"><td>Estimasi produksi plts</td>
                        <td class="tdr">{{result.electricProduced50
                        .toLocaleString('id')}} kWh/bulan )*<sup>1</sup></td></tr>
                      <tr><td>Kebutuhan modul</td><td class="tdr">
                        {{result.moduleCount50}} Modul {{result.solarModule}} Wp</td></tr>
                      <tr><td>Perkiraan biaya</td><td class="tdr">Rp
                        {{result.costEstimated50.toLocaleString('id')}} )*<sup>2</sup></td></tr>
                    </table>
                  </div>
                  <div class="carbonInfo">
                    <div class="icon leaf"></div>
                    Karbon yang dapat dihindari
                    {{result.co2PerKwhInTon50.toLocaleString('id')}} Ton per bulan,
                    atau setara dengan mengendarai mobil sejauh
                    <b>{{result.kmCar50.toLocaleString('id')}} Kilometer</b>
                  </div>
                  <div class="priceInfo">
                    )*<sup>1</sup> Estimasi produksi plts mungkin akan berbeda
                    tergantung cuaca sekitar tempat pemasangan solar panel
                  </div>
                  <div class="priceInfo">
                    )*<sup>2</sup> Perkiraan biaya diambil dari rata-rata nilai
                    jual solar panel dan belum termasuk batre, mungkin akan berbeda sesuai dengan
                    produsen solar panel dan biaya pemasangan di tiap daerah.
                  </div>
                </div>
                <div class="outputItem" :class="{folded: folded.o4}"
                  v-on:click="folded.o4 = !folded.o4">
                  <h4>Sistem {{result.systemCapacity25}} kWp
                    <span><div class="icon flash"></div> 25%</span></h4>
                  <p>Kebutuhan kapasitas solar panel (Modul {{result.solarModule}} Wp)</p>
                  <div class="tableCnt">
                    <table colspan="0" rowspan="0">
                      <tr class="bold"><td>Rekomendasi sistem</td>
                        <td class="tdr">{{result.systemCapacity25}} kWp</td></tr>
                      <tr class="bold"><td>Estimasi produksi plts</td>
                        <td class="tdr">{{result.electricProduced25
                          .toLocaleString('id')}} kWh/bulan )*<sup>1</sup></td></tr>
                      <tr><td>Kebutuhan modul</td><td class="tdr">
                        {{result.moduleCount25}} Modul {{result.solarModule}} Wp</td></tr>
                      <tr><td>Perkiraan biaya</td><td class="tdr">Rp
                        {{result.costEstimated25.toLocaleString('id')}} )*<sup>2</sup></td></tr>
                    </table>
                  </div>
                  <div class="carbonInfo">
                    <div class="icon leaf"></div>
                    Karbon yang dapat dihindari
                    {{result.co2PerKwhInTon25.toLocaleString('id')}} Ton per bulan,
                    atau setara dengan mengendarai mobil sejauh
                    <b>{{result.kmCar25.toLocaleString('id')}} Kilometer</b>
                  </div>
                  <div class="priceInfo">
                    )*<sup>1</sup> Estimasi produksi plts mungkin akan berbeda
                    tergantung cuaca sekitar tempat pemasangan solar panel
                  </div>
                  <div class="priceInfo">
                    )*<sup>2</sup> Perkiraan biaya diambil dari rata-rata nilai
                    jual solar panel dan belum termasuk batre, mungkin akan berbeda sesuai dengan
                    produsen solar panel dan biaya pemasangan di tiap daerah.
                  </div>
                </div>
              </div>
            </div>
            <div class="actions">
              <button class="btn secondary" v-on:click="saveCalc">
                <div class="icon bookmarkOutline"></div>Simpan Hasil Kalkulasi</button>
              <button class="btn secondary" v-on:click="openShare">
                <div class="icon shareSocialOutline"></div>Bagikan Hasil Kalkulasi</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Snackbar ref="snackbar"/>
    <ShareDialog ref="shareDialog"/>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';
import Snackbar from '@/components/Snackbar.vue';
import ShareDialog from '@/components/ShareDialog.vue';

export default {
  name: 'home',
  components: { Header, Snackbar, ShareDialog },
  data() {
    return {
      loading: false,
      scrolled: false,
      form: {
        type: { model: 'prabayar' },
        power: { model: '' },
        cost: { model: '', error: '' },
      },
      folded: { o2: true, o3: true, o4: true },
      solarModule: 350,
      powerType: [],
      name: '',
      location: null,
      result: null,
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.headerClicked();
    },
    docScrolled() {
      this.scrolled = (window.pageYOffset >= 30);
    },
    moduleChanged() {
      this.calcNow();
    },
    saveCalc() {
      this.$refs.snackbar.open({ content: 'Hasil kalkulasi tersimpan' });
    },
    openShare() {
      this.$refs.shareDialog.open();
    },
    getPowerType() {
      this.powerType = [];
      this.$http.get(this.$config.uri('misc/power/type')).then((r) => {
        this.powerType = (r.data.status === 200) ? r.data.data : [];
        if (this.powerType.length > 1) {
          this.form.power.model = String(this.powerType[1].id);
        } else if (this.powerType.length > 0) {
          this.form.power.model = String(this.powerType[0].id);
        }
        if (this.$route.query.cost) this.calcNow();
      });
    },
    getLocation() {
      const { id } = this.$route.params;
      this.$http.get(this.$config.uri(`misc/location/${id}`)).then((r) => {
        this.location = (r.data.status === 200) ? r.data.data : null;
        this.name = (this.location) ? this.location.name : '';
        if (this.$route.query.cost) this.calcNow();
      });
    },
    getData() {
      this.loading = true;
      const parentId = this.newsCategory[this.categorySelected].id;
      this.$http.get(this.$config.uri(`article/all?parentId=${parentId}`)).then((r) => {
        this.loading = false;
        this.results = (r.data.status === 200) ? r.data.data : [];
      });
    },
    calcNow() {
      if (this.loading || !this.location) return;
      const formData = {
        locationId: this.location.id,
        powerId: this.form.power.model,
        cost: this.form.cost.model,
        module: this.solarModule,
        type: this.form.type.model,
      };
      if (!formData.cost || formData.cost === '') {
        this.form.cost.error = 'Mohon isi biaya rata-rata per bulan';
        return;
      }
      if (!formData.powerId || formData.powerId === '') return;
      this.loading = true;
      this.$http.post(this.$config.uri('calc'), formData).then((r) => {
        this.loading = false;
        window.history.replaceState({}, this.location.id, `/calc/${this.location.id}?cost=${formData.cost}`);
        if (r.data.status !== 200) {
          const message = r.data.message || 'Internal server error';
          this.form.cost.error = message;
          return;
        }
        this.result = r.data.data;
      });
    },
  },
  created() { document.addEventListener('scroll', this.docScrolled); },
  destroyed() { document.removeEventListener('scroll', this.docScrolled); },
  mounted() {
    this.getLocation();
    this.getPowerType();
    if (this.$route.query.cost) this.form.cost.model = this.$route.query.cost;
  },
};
</script>

<style scoped lang="scss">
.pageSupport{
  padding-top: 140px;
  @media (max-width: 840px) {
    padding-top: 120px;
  }
  @media (max-width: 760px) {
    padding-top: 100px;
  }
  .pageTitle{
    font-size: 40px;
    margin: 0 0 10px;
    @media (max-width: 840px) {
      font-size: 36px;
    }
    @media (max-width: 760px) {
      font-size: 30px;
    }
    @media (max-width: 680px) {
      font-size: 24px;
    }
  }
  .pageSubtitle{
    margin: 0 0 20px;
  }
}
.form{
  border-top: #eee 1px solid;
  .cnt{
    display: flex;
    @media (max-width: 860px) {
      display: block;
    }
    .theForm{
      width: 400px;
      padding: 40px 0 60px;
      box-sizing: border-box;
      @media (max-width: 860px) {
        width: auto;
      }
      .fieldCnt{
        position: relative;
        .field{
          padding-left: 48px;
          text-align: left;
        }
        .icon{
          position: absolute;
          left: 10px; top: 9px;
          width: 30px; height: 30px;
          z-index: 3;
          background-size: 22px auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .54;
          &.location{
            background-image: url(../assets/location.svg);
          }
          &.flash{
            background-image: url(../assets/flash.svg);
          }
          &.cashOutline{
            background-image: url(../assets/cash-outline.svg);
          }
          &.speedometer{
            background-image: url(../assets/speedometer.svg);
          }
        }
      }
      .btn{
        width: 100%;
      }
    }
    .theResult{
      width: calc(100% - 460px);
      border-left: #eee 1px solid;
      margin-left: auto;
      padding-left: 60px;
      box-sizing: border-box;
      position: relative;
      @media (max-width: 1080px) {
        padding-left: 40px;
        width: calc(100% - 440px);
      }
      @media (max-width: 960px) {
        padding-left: 20px;
        width: calc(100% - 420px);
      }
      @media (max-width: 860px) {
        width: auto;
        border: none;
        padding-left: 0;
      }
      &.loading{
        &:before{
          content: "";
          position: absolute;
          left: 0; right: 0; top: 0; bottom: 0;
          background-color: #fff;
          background-image: url(../assets/loading.svg);
          background-size: 46px auto;
          background-position: center;
          background-repeat: no-repeat;
        }
      }
      #result{
        padding: 40px 0;
        max-width: 600px;
        @media (max-width: 860px) {
          max-width: none;
        }
      }
      .input{
        label{
          margin: 0 0 4px;
          display: block;
          font-size: 17px;
          font-weight: 700;
        }
        .inputCnt{
          display: flex;
          margin: 0 0 20px;
          .inputItem{
            width: 33.3333%;
            position: relative;
            padding-left: 26px;
            border-radius: 5px;
            .icon{
              position: absolute;
              left: 0; top: 4px;
              width: 30px; height: 30px;
              background-size: 20px auto;
              background-position: left top;
              background-repeat: no-repeat;
              opacity: .54;
              &.location{
                background-image: url(../assets/location.svg);
              }
              &.flash{
                background-image: url(../assets/flash.svg);
              }
              &.cashOutline{
                background-image: url(../assets/cash-outline.svg);
              }
              &.speedometer{
                background-image: url(../assets/speedometer.svg);
              }
            }
            span{
              color: #767676;
              font-size: 13px;
            }
            .inputValue{
              font-size: 15px;
            }
          }
        }
      }
      .output{
        .fieldGroup{
          label{
            margin: 0 0 4px;
            display: block;
            font-size: 17px;
            font-weight: 700;
            color: inherit;
            padding: 0;
            text-transform: none;
          }
        }
        h4{
          font-size: 16px;
          line-height: 1.2;
          font-weight: 600;
          margin: 0 0 12px;
        }
        .openSignup{
          color: #02b5ff;
          margin: 0 0 24px;
          font-size: 14px;
          border: #02b5ff 1px solid;
          border-radius: 50px;
          padding: 5px 12px;
          display: inline-block;
          cursor: pointer;
          transition: all .3s ease;
          &:hover{
            box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
          }
        }
        .outputCnt{
          .outputItem{
            border: #eee 1px solid;
            border-radius: 10px;
            padding: 16px 20px 6px;
            box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
            margin-bottom: 10px;
            overflow: hidden;
            &.main{
              border-color: #02b5ff;
            }
            h4{
              margin: -16px -20px 10px;
              padding: 14px 20px 12px;
              border-bottom: #eee 1px solid;
              cursor: pointer;
              transition: all .3s ease;
              &:hover{
                background-color: #f5f5fe;
              }
              span{
                float: right;
                color: #ff8600;
                .icon{
                  float: left;
                  margin: 0px 4px -10px;
                  width: 20px; height: 20px;
                  background-image: url(../assets/flash-orange.svg);
                  background-position: center;
                  background-repeat: no-repeat;
                  background-size: 20px auto;
                }
              }
            }
            p{
              color: #444;
              margin: 0 0 6px;
            }
            .tableCnt{
              margin: 0 0 14px;
              table{
                width: 100%;
                tr{
                  td{
                    font-size: 14px;
                    padding: 8px 0 6px;
                    border-bottom: #eee 1px dashed;
                    &.tdr{
                      text-align: right;
                    }
                  }
                  &.bold{
                    td{
                      font-weight: bold;
                    }
                  }
                }
              }
            }
            .priceInfo{
              font-size: 14px;
              line-height: 1.1;
              color: #555;
              margin-bottom: 10px;
            }
            .carbonInfo{
              color: green;
              position: relative;
              padding-left: 30px;
              font-size: 14px;
              margin-bottom: 10px;
              .icon{
                width: 20px; height: 20px;
                background-image: url(../assets/leaf.svg);
                position: absolute;
                left: 0; top: 0;
              }
            }
            &.folded{
              h4{
                border: none;
                margin-bottom: -6px;
                padding-bottom: 14px;
              }
              p, .tableCnt, .priceInfo, .carbonInfo{
                display: none;
              }
            }
          }
        }
      }
      .actions{
        padding: 20px 0;
        display: flex;
        justify-content: space-between;
        @media (max-width: 1080px) {
          display: block;
        }
        button{
          margin-bottom: 10px;
          font-size: 17px;
          text-align: left;
          font-weight: 600;
          border: #02b5ff 1px solid;
          width: calc(50% - 10px);
          @media (max-width: 1080px) {
            width: 100%;
          }
          .icon{
            float: left;
            margin: 0px 8px -10px 0;
            width: 24px; height: 24px;
            background-position: center;
            background-repeat: no-repeat;
            background-size: 24px auto;
            &.bookmarkOutline{
              background-image: url(../assets/bookmark-outline-blue.svg);
            }
            &.shareSocialOutline{
              background-image: url(../assets/share-social-outline-blue.svg);
            }
          }
        }
      }
    }
  }
}
.pageSupport.hasResult{
  @media (max-width: 860px) {
    .cntTitle{
      display: none;
    }
    .theForm{
      display: none;
    }
    .form{
      border: none;
      .theResult{
        #result{
          padding-top: 0;
          .backBtn{
            width: 40px; height: 40px;
            border-radius: 50%;
            background-image: url(../assets/back-arrow-black.png);
            background-size: 20px auto;
            background-position: center;
            background-repeat: no-repeat;
            margin: -10px 0 14px -10px;
            opacity: .65;
            cursor: pointer;
            &:hover{
              background-color: #eee;
            }
          }
        }
      }
    }
  }
}
</style>
